import axios from "axios";
import { environment } from "../../environments/environment";
import { ILogin } from "../../models/ILogin";
import { Auth_URL } from "../../constants/backendUrl";
import EncryptionService from "../EncryptionService";

export class LoginService {
  private static URL: any = environment.authApiUrl;

  public static login(data: ILogin) {
    const requestData: ILogin = {
			...data,
			password: EncryptionService.encryptPassword(data.password)
		};
    let UserURL: any = `${this.URL}/${Auth_URL.login}`;
    return axios.post<any>(UserURL, requestData);
  }
  public static logout() {
    let UserURL: any = `${this.URL}/${Auth_URL.logout}`;
    const config = {
      headers: { Authorization: `Bearer ${sessionStorage.getItem("Token")}` },
    };
    return axios.get<any>(UserURL, config);
  }
  public static updatetoken() {
    let UserURL: any = `${this.URL}/${Auth_URL.updateToken}`;
    const config = {
      headers: { Authorization: `Bearer ${sessionStorage.getItem("Token")}` },
    };
    return axios.get<any>(UserURL, config);
  }
}
